/**
 * @function updateStickyATC
 * @description Updates the token count and price in the sticky ATC button
 */
function updateStickyATC() {
    const stickyATC = document.querySelector('.footer-interactive-button-xs');
    if (!stickyATC) return;

    const tokenCount = stickyATC.querySelector('.token-count');
    const tokenPrice = stickyATC.querySelector('.token-price');
    
    // Get total tokens
    let totalTokens = 0;
    for (const tokenId in selectedTokens) {
        totalTokens += selectedTokens[tokenId].count;
    }

    // Get product price and remove currency symbol
    const priceElement = document.querySelector('.current-price.theme-money');
    const priceText = priceElement ? priceElement.textContent.trim() : '0';
    const productPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    
    // Update display
    tokenCount.textContent = `${totalTokens} token${totalTokens !== 1 ? 's' : ''}`;
    tokenPrice.textContent = `£${(totalTokens * productPrice).toFixed(2)}`;
}

/**
 * @function handleStickyAddToCart
 * @description Handles the click event for the sticky add to cart button
 */
function handleStickyAddToCart() {
    const stickyAddToCart = document.querySelector('.product-area__add-to-cart button');
    if (stickyAddToCart) {
        stickyAddToCart.addEventListener('click', function(event) {
            event.preventDefault();
            
            // Find the main add to cart button
            const mainAddToCartButton = document.querySelector('.product-purchase-form button[type="submit"][name="add"]');
            if (mainAddToCartButton) {
                // Simulate click on the main add to cart button
                mainAddToCartButton.click();
            }
        });
    }
}

// prevent right-click on any token item or its image
document.addEventListener('contextmenu', e => {
  if (e.target.closest('[data-disable-contextmenu]')) {
    e.preventDefault();
  }
});

// 1) Build a registry of all fit-text elements
  const registry = [];  // each entry: { el, span, defaultText, fit, inputId }

  document.querySelectorAll("[data-fit-text]").forEach(el => {
    const defaultText = el.getAttribute("data-fit-default") || "";
    const inputId     = el.getAttribute("data-fit-input");
    let   span        = el.querySelector("span");

    // wrap in a span if needed
    if (!span) {
      span = document.createElement("span");
      span.textContent = defaultText || el.textContent.trim();
      el.textContent = "";
      el.appendChild(span);
    }

    // fit function specific to this element/span
    const fit = () => {
      span.style.transform = "scale(1)";
      const scale = Math.min(1, el.clientWidth / span.clientWidth);
      span.style.transform = `scale(${scale})`;
    };

    // observe container size changes
    new ResizeObserver(fit).observe(el);

    // do initial fit
    fit();

    // add to registry
    registry.push({ el, span, defaultText, fit, inputId });
  });

  // 2) Now, outside that loop, wire up any inputs
  registry.forEach(entry => {
    if (!entry.inputId) return;           // skip those with no input
    const input = document.getElementById(entry.inputId);
    if (!input) return;                   // skip if input not found

    input.addEventListener("input", () => {
      entry.span.textContent = input.value.trim() || entry.defaultText;
      entry.fit();
    });
  });